import styled from 'styled-components'
import colors from './../../styles/colors'
import easings from './../../styles/easings'

import border from './../../../img/button-border-red.png'

export const StyledButton = styled.button`
  background: none;
  appearance: none;
  outline: none;
  cursor: pointer;

  position: relative;
  display: inline-block;
  padding: 0.5rem 2.5rem;
  font-size: 1.3rem;

  text-transform: uppercase;
  letter-spacing: 2px;
  color: #e6c3b4;

  border-image: url(${border});
  border-image-slice: ${260 / 3};
  border-image-width: 50px;

  transition: all 600ms ${easings.easeOutQuart};

  :focus,
  :active,
  :hover {
    transform: translateY(-3px);
  }

  ::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: calc(100% - 60px);
    height: calc(100% - 60px);
    background: ${colors.red};
  }

  & > * {
    position: relative;
  }

  a {
    text-decoration: none !important;
  }
`
